import { api } from "./configs/axiosConfigs"

export const WayToPayAPI = {
    getWayToPay: async (data:any) => {
        const response = await api.get(
            '/waytopay', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getWayToPayByCompany: async (data:any) => {
        const response = await api.get(
            '/waytopay/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getPaymentTools: async (data:any) => {
        const response = await api.get(
            '/waytopay/listPaymentTools', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getPaymentCuotas: async (data:any) => {
        const response = await api.get(
            '/waytopay/listPaymentCuotas', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}